let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cGbhj")).then(() => parcelRequire('kZaQu'));